import React, { RefObject } from 'react';
import { SubTitle } from './SubTitle/SubTitle';
import { SubText } from './SubText/SubText';
import { SubHeaderBreadcrumbs } from './SubHeaderBreadcrumbs/SubHeaderBreadcrumbs';
import { SubCategories } from './SubCategories/SubCategories';
import { subHeaderDataHooks } from './SubHeader.dataHooks';
import s from './SubHeader.scss';

interface SubHeaderProps {
  children?: undefined;
  dataHook?: string;
  subTitleRef?: RefObject<HTMLHeadingElement>;
}

export const SubHeader: React.FC<SubHeaderProps> = ({ dataHook, subTitleRef }) => (
  <div className={s.root} data-hook={dataHook}>
    <SubHeaderBreadcrumbs dataHook={subHeaderDataHooks.breadcrumbs()} />
    <SubTitle dataHook={subHeaderDataHooks.subTitle()} subTitleRef={subTitleRef} />
    <SubText dataHook={subHeaderDataHooks.subText()} />
    <SubCategories dataHook={subHeaderDataHooks.subCategories()} />
  </div>
);
